export default __webpack_public_path__ + "static/media/TWITTER-BANNER.e69fbbb7.jpg";